// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-wrapper {
  width: 80%;
  padding-bottom: 9rem;
  padding-top: 5rem;
  position: relative;
  border: 1px solid #F2EEFF;
  background-color: white;
  margin: 4rem;
  padding: 3rem;
  border-radius: 17px;
}
.form-outer-wrapper {
  width: 70%;
  margin-top: 3rem;
}
.form-outer-wrapper form {
  width: 100%;
}
.form-heading h3{
  font-weight: 600;
  font-size: 2rem;
  color: #573CFF;
  width: max-content;
  margin: 0;
}
.form-heading{
  background-color: #F5F3FF;
  width: max-content;
  padding: 1rem;
  border-radius: 6px;
}
.form-wrapper form .row {
  margin-bottom: 3rem;
}

.form-wrapper form .row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.form-field {
  display: flex;
  flex-direction: column;
  row-gap: 0.2rem;
  column-gap: 4rem;
  position: relative;
}

.name,
.email,
.country,
.company-name {
  width: 100%;
}

.form-wrapper form .row:nth-child(4) > div {
  width: 48%;
}

.heading-inner {
  margin-top: 2.5rem;
}

.heading-inner h2 {
  font-size: 2.4rem;
  font-weight: 600;
  color: #02015A;
  margin-bottom: 1rem;
}
.form-field label{
  font-size: 1.6rem;
}
.questions-wrapper {
  padding: 3rem 0;
  overflow-y: auto;
  height: 66%;
}
.questions-wrapper::-webkit-scrollbar {
  display: none; /* Hides the scrollbar */
}
.schedule-demo-wrapper {
  height: 100%;
}

.schedule-demo-top {
  display: flex;
}

.schedule-demo-left {
  width: 77%;
}

.schedule-demo-right {
  width: 23%;
  margin-top: 1rem;
}

@media (min-width: 1850px) {
  .form-outer-wrapper form {
    /* width: 70%; */
  }
}

@media (max-width: 1440px) {
  .schedule-demo-left {
    width: 66%;
  }
  .form-outer-wrapper {
    margin-top: 2rem;
}
.form-wrapper form .row {
  margin-bottom: 3rem;
}
  .schedule-demo-right {
    width: 34%;
  }
  .form-wrapper {
    width: 68%;
  }
  .form-outer-wrapper {
    width: 80%;
  }
}

@media (max-width: 1024px) {
  .schedule-demo-top {
    flex-direction: column;
  }

  .schedule-demo-left {
    width: 100%;
  }
  .schedule-demo-top {
    padding-bottom: 2rem;
  }
  .schedule-demo-right {
    width: 100%;
    margin-top: 0;
  }
  .form-outer-wrapper {
    width: 88%;
  }
}

@media (max-width: 768px) {
  .form-wrapper {
    width: auto;
    padding-bottom: 9rem;
  }

  .form-outer-wrapper .row {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 3rem;
    margin-bottom: 3rem !important;
  }
  .form-outer-wrapper {
    width: 100%;
  }
  .form-outer-wrapper .row:nth-child(3) > div,
  .form-outer-wrapper .row:nth-child(4) > div {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Forms/Forms.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa,EAAE,wBAAwB;AACzC;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;AACpB;AACA;EACE,mBAAmB;AACrB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,SAAS;IACT,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;EACA;;IAEE,sBAAsB;EACxB;AACF","sourcesContent":[".form-wrapper {\n  width: 80%;\n  padding-bottom: 9rem;\n  padding-top: 5rem;\n  position: relative;\n  border: 1px solid #F2EEFF;\n  background-color: white;\n  margin: 4rem;\n  padding: 3rem;\n  border-radius: 17px;\n}\n.form-outer-wrapper {\n  width: 70%;\n  margin-top: 3rem;\n}\n.form-outer-wrapper form {\n  width: 100%;\n}\n.form-heading h3{\n  font-weight: 600;\n  font-size: 2rem;\n  color: #573CFF;\n  width: max-content;\n  margin: 0;\n}\n.form-heading{\n  background-color: #F5F3FF;\n  width: max-content;\n  padding: 1rem;\n  border-radius: 6px;\n}\n.form-wrapper form .row {\n  margin-bottom: 3rem;\n}\n\n.form-wrapper form .row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.2rem;\n  column-gap: 4rem;\n  position: relative;\n}\n\n.name,\n.email,\n.country,\n.company-name {\n  width: 100%;\n}\n\n.form-wrapper form .row:nth-child(4) > div {\n  width: 48%;\n}\n\n.heading-inner {\n  margin-top: 2.5rem;\n}\n\n.heading-inner h2 {\n  font-size: 2.4rem;\n  font-weight: 600;\n  color: #02015A;\n  margin-bottom: 1rem;\n}\n.form-field label{\n  font-size: 1.6rem;\n}\n.questions-wrapper {\n  padding: 3rem 0;\n  overflow-y: auto;\n  height: 66%;\n}\n.questions-wrapper::-webkit-scrollbar {\n  display: none; /* Hides the scrollbar */\n}\n.schedule-demo-wrapper {\n  height: 100%;\n}\n\n.schedule-demo-top {\n  display: flex;\n}\n\n.schedule-demo-left {\n  width: 77%;\n}\n\n.schedule-demo-right {\n  width: 23%;\n  margin-top: 1rem;\n}\n\n@media (min-width: 1850px) {\n  .form-outer-wrapper form {\n    /* width: 70%; */\n  }\n}\n\n@media (max-width: 1440px) {\n  .schedule-demo-left {\n    width: 66%;\n  }\n  .form-outer-wrapper {\n    margin-top: 2rem;\n}\n.form-wrapper form .row {\n  margin-bottom: 3rem;\n}\n  .schedule-demo-right {\n    width: 34%;\n  }\n  .form-wrapper {\n    width: 68%;\n  }\n  .form-outer-wrapper {\n    width: 80%;\n  }\n}\n\n@media (max-width: 1024px) {\n  .schedule-demo-top {\n    flex-direction: column;\n  }\n\n  .schedule-demo-left {\n    width: 100%;\n  }\n  .schedule-demo-top {\n    padding-bottom: 2rem;\n  }\n  .schedule-demo-right {\n    width: 100%;\n    margin-top: 0;\n  }\n  .form-outer-wrapper {\n    width: 88%;\n  }\n}\n\n@media (max-width: 768px) {\n  .form-wrapper {\n    width: auto;\n    padding-bottom: 9rem;\n  }\n\n  .form-outer-wrapper .row {\n    flex-direction: column;\n    align-items: flex-start !important;\n    gap: 3rem;\n    margin-bottom: 3rem !important;\n  }\n  .form-outer-wrapper {\n    width: 100%;\n  }\n  .form-outer-wrapper .row:nth-child(3) > div,\n  .form-outer-wrapper .row:nth-child(4) > div {\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
